import FastForwardComponent from './index.js'

if (!window.AliPlayerComponent) {
  window.AliPlayerComponent = {}
}
window.AliPlayerComponent.FastForwardComponent = FastForwardComponent



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/components/FastForwardComponent/export.js